import { CartContextProvider, CartContextConsumer, withCart } from "./Context";

import ModuleLoader from "ModuleLoader";

const CartComponent = ModuleLoader("Cart");

// export default connect()(CartComponent)
export default CartComponent;

export { CartContextProvider, CartContextConsumer, withCart };